const zh = {
  currencyList: {
    hkd: '港币$',
    cny: '人民币￥'
  },
  payBefore: {
    pending: '待付款',
    totalPrice: '总价',
    paymentClosingDate: '付款截止日期:',
    customerInformation: '客户信息',
    telephone: '电话',
    name: '姓名',
    mailbox: '邮箱',
    mailboxTips: '请输入您的邮箱地址，我们会发送订单信息到您的邮箱',
    logistics: '物流', // 确认一下
    logisticsMode: {
      title: '物流方式',
      mode1: '无物流',
      mode2: '送货或自取',
      mode3: '送货',
      mode4: '自取'
    },
    expectedDeliveryTime: '预期送货时间:',
    remarks: '备注',
    terms: '本人清楚及了解有关推广活动条款细节及',
    termsLink: '隐私政策',
    payNow: '支付',
    errorMessage: {
      phone: '电话号码未填写',
      phoneFormate: '电话号码格式不正确',
      name: '姓名未填写',
      logisticsMode: '请选择物流方式',
      otherValid: '不可输入特殊字符',
      invalidEmail: '无效的邮箱格式'
    },
    placeholder: {
      name: '请输入姓名',
      phone: '请输入电话',
      email: '请输入邮箱',
      address: '请输入地址'
    }
  },
  privacyPolicy: {
    head: '隐私政策',
    contentTitle: '当您访问由 QFPay Haojin Fintech Limited 托管的QFPay网站时，请与我们联系，使用QF Pay商家APP或成为（或正在成为我们的商人或合作伙伴之一，我们将作为数据控制者处理有关您的个人数据。对我们而言，重要的是，应谨慎对待应用程序用户，网站访问者，（潜在）商人和（未来）合作伙伴（“您”）的访问者的个人数据，并且您应充分了解我们处理您的个人数据的方式。通过选择 QFPay Haojin Fintech Limited。（“ QFPay”，“我们”，“我们”或“我们的”）作为您的支付服务技术解决方案提供商。我们完全致力于确保我们收集的所有信息以及用户权利得到良好保护。本隐私政策描述了我们将在qfpay.global（“网站”）上收集的信息类型，信息的使用案例以及您与之相关的权利。',
    title_one: '1.我们收集的个人信息',
    content_one: `当您访问本网站时，我们会自动收集有关您设备的某些信息，包括有关您的Web浏览器，IP地址，时区以及设备上安装的某些Cookie的信息。此外，在您浏览网站时，我们会收集有关您查看的各个网页或产品的信息，哪些网站或搜索字词将您引荐到该网站以及有关您如何与该网站进行交互的信息。我们将此自动收集的信息称为“设备信息”。我们使用以下技术收集设备信息：-“ Cookie”是放置在设备或计算机上的数据文件，通常包含匿名唯一标识符。有关cookie以及如何禁用cookie的更多信息，请访问http://www.allaboutcookies.org。
-“日志文件”跟踪站点上发生的操作，并收集数据，包括您的IP地址，浏览器类型，Internet服务提供商，引荐/退出页面和日期/时间戳。
-“网络信标”，“标签”和“像素”是用于记录有关您如何浏览网站的信息的电子文件。

此外，当您尝试通过电子邮件或联系表通过网站与我们联系或与我们联系时，我们会从您那里收集某些信息，包括您的姓名，电子邮件地址，位置，个人信息和电话号码。我们将此信息称为“联系信息”。当我们在本隐私政策中谈论“个人信息”时，我们既在谈论设备信息又在订购信息。`,
    title_two: '2.我们如何使用您的个人信息',
    content_two: `我们使用通常收集的订单信息来处理通过网站发出的联系请求（包括处理您的个人或公司信息，安排产品演示并向您提供有关产品和服务的数据和/或信息）。此外，我们使用此联系信息来：
与您交流；
筛选我们的订单以发现潜在的风险或欺诈行为；和
根据您与我们分享的偏好，向您提供与我们的产品或服务有关的信息或广告。

我们使用收集到的设备信息来帮助我们筛查潜在的风险和欺诈行为（特别是您的IP地址），并且更广泛地改善和优化我们的网站（例如，通过生成有关客户如何浏览和互动的分析）网站，并评估我们的营销和广告活动的成功）。
如上所述，我们与第三方共享您的个人信息，以帮助我们使用您的个人信息。例如，我们使用Google Analytics（分析）来帮助我们了解客户如何使用本网站-您可以在此处阅读有关Google如何使用您的个人信息的更多信息：https://www.google.com/intl/zh-CN/policies/privacy/ 。您还可以在此处退出Google Analytics（分析）：https：//tools.google.com/dlpage/gaoptout。最后，我们还可能会分享您的个人信息，以遵守适用的法律和法规，以回应传票，搜查令或其他合法要求提供的信息，或以其他方式保护我们的权利。`,
    title_three: '3.行为广告',
    content_three: '如上所述，我们使用您的个人信息为您提供有针对性的广告或市场传播信息，我们认为您可能对此感兴趣。有关定向广告如何工作的更多信息，您可以访问网络广告计划（“ NAI”）的教育页面，网址为http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work。',
    title_four: '4.您的权利',
    content_four: '如果您是欧洲居民，则有权访问我们持有的有关您的个人信息，并要求更正，更新或删除您的个人信息。如果您想行使此权利，请通过以下联系信息与我们联系。此外，如果您是欧洲居民，请注意，我们正在处理您的联系请求以便为您提供服务。',
    title_five: '5.数据保留',
    content_five: '当您通过本网站创建联系请求时，除非您要求我们删除此信息，否则我们将保留您的个人信息作为我们的记录。 我们可能会不时更新本隐私政策，以反映（例如）我们做法的更改或出于其他运营，法律或法规方面的原因。',
    title_six: '6.联系我们',
    content_six: `有关我们的隐私惯例的更多信息，如果您有任何疑问，或者您想提出投诉，请通过电子邮件发送给我们：客户服务部 hkcs@qfpay.com。钱方好近金融科技有限公司，香港长沙湾荔枝角道777号天时企业中心12楼1207-09室。

    本隐私政策的最新更新时间为2021年8月05日。`
  },
  payResult: {
    result: '支付结果',
    voucher: '凭证',
    paymentVoucher: '支付凭证',
    mchtName: '店铺名称:',
    mchtOrderId: '商户订单号:',
    payOrderId: '支付订单号:',
    payTime: '支付时间:',
    totalPrice: '总价:',
    logisticsMode: {
      title: '物流方式:',
      mode1: '无物流',
      mode2: '送货或自取',
      mode3: '送货',
      mode4: '自取'
    },
    mchtAddress: '店铺地址:',
    address: '地址:',
    mchtMailbox: '店铺邮箱:',
    mchtTelephone: '店铺电话:',
    accept: '本人欲知晓及接受QFPAY Haojin Fintech Limited的最新消息及推广',
    confirm: '确认',
    queryStatus: '订单状态查询',
    payAgain: '再次支付',
    status: '状态:',
    customerName: '客户姓名:',
    CustomerTelephone: '客户电话:',
    success: '成功',
    failure: '失败',
    processing: '处理中',
    estTime: '',
    save: '保存',
    saveTo: '保存到相册'
  }
}

export default zh
